import React from "react";
import { withRouter, Route, Redirect } from "react-router-dom";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
function ProtectedRoute({ component: ComponentToRender, ...rest }) {
  let { is_authenticated, hasAnyPrivilege } = rest.context;
  let { privileges, access = false } = rest;

  return (
    <Route
      {...rest}
      render={props => {
        if (!is_authenticated) {
          return <Redirect to="/login" />;
        }

        if (!access && !hasAnyPrivilege(privileges)) {
          return <Redirect to="/home/unauthorized" />;
        }
        return <ComponentToRender {...props} />;
      }}
    />
  );
}

export default withRouter(withSharedStateConsumer(ProtectedRoute));
